module.exports = __webpack_public_path__ + "static/img/y25-3.bc779ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y25-3.png
// module id = /dN2
// module chunks = 1